import 'react';
console.log('keyboard is not supported on web');
const CustomKeyboardView = () => {
  return null;
};
export default CustomKeyboardView;